import { IconSymbol } from '@abyss/web/ui/IconSymbol';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import {
  MatchStyledText,
  StyledFlexWithGapAndNoWrap,
} from '../../SmartChoiceBreakDown.styles';
import { StyledLinkViewMore } from '../ConvenienceBreakDown.styles';

interface MatchTextWithViewMoreProps {
  text: string;
}
export const MatchTextWithViewMore = ({ text }: MatchTextWithViewMoreProps) => {
  const [isScAppointmentAvailabilityEnabled] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_SC_APPOINTMENT_AVAILABILITY,
  ]);
  return (
    <StyledFlexWithGapAndNoWrap alignItems="flex-start" direction="row">
      <IconSymbol color="#007000" icon="done" />
      <StyledFlexWithGapAndNoWrap alignItems="flex-start" direction="column">
        <MatchStyledText>{text}</MatchStyledText>
        {!isScAppointmentAvailabilityEnabled && (
          <StyledLinkViewMore
            data-testid="locations-link"
            href="/locations"
            onClick={() => {
              adobeLinkTrackEvent({
                name: 'View now: availability',
                location: 'Smart choice convenience breakdown',
              });
            }}
          >{`View now > `}</StyledLinkViewMore>
        )}
      </StyledFlexWithGapAndNoWrap>
    </StyledFlexWithGapAndNoWrap>
  );
};
